import { TICKET_STATUS_VALUES } from "@/lib/constants/ticket-statuses";
import type { Ticket_Status } from "@/src/gql/graphql";

const TICKET_STATUS_LABELS: Record<Ticket_Status, string> = {
  new: "New",
  assigned: "Assigned",
  in_progress: "In Progress",
  waiting_for_customer: "Waiting for Customer",
  waiting_for_vendor: "Waiting for Vendor",
  resolved: "Resolved",
  closed: "Closed",
  cancelled: "Cancelled",
};

/** UI select options — values from `TICKET_STATUS_VALUES`. */
export const TICKET_STATUS_OPTIONS = TICKET_STATUS_VALUES.map((value) => ({
  label: TICKET_STATUS_LABELS[value],
  value,
}));
